import axios from '@/libs/api.request';
import axiosRequest from 'axios';
import search from '@/libs/search';

import { getAreaList } from '@/api/modules/system-management/area-management';

export const getAdminUserList = data => {
    return axios.request({
        url: 'api/accountManagement/adminUserManagement/getAdminUserList',
        data: data,
        method: 'post'
    });
};

export const getAdminUserDetail = userAdminLoginUuid => {
    return axios.request({
        url: 'api/accountManagement/adminUserManagement/getAdminUserDetail',
        data: { userAdminLoginUuid },
        method: 'post'
    });
};

export const pageInit4UserAdminEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch)
    ]).then(axiosRequest.spread(function (area) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data
                }
            };
        }
    }));
};

export const adminUserSave = data => {
    return axios.request({
        url: 'api/accountManagement/adminUserManagement/adminUserSave',
        data: data,
        method: 'post'
    });
};
